import React, { type PropsWithChildren } from 'react'

import styles from './round-icon.module.scss'

export const RoundIcon: React.FC<PropsWithChildren> = ({ children }) => {
    return <div className={styles['round-icon']}>{children}</div>
}
